import axios from "./userInstance"

export default async (roleId: string, permissionId: string) => {
  const data = {
    "role_id": roleId,
    "permission_ids": [permissionId],
  };
  const response = await axios.delete(`/role/permissions`, {
      data
  })
  return response.data
}
